import React from 'react';
import Card from './Card';
import { CardData } from '../types';

export interface CardListProps {
  cards: CardData[];
  selectedCard?: CardData | null;
  onCardClick?: (card: CardData) => void;
  onViewOnMap?: (card: CardData) => void;
  layout?: 'stack' | 'grid';
}

export const CardList: React.FC<CardListProps> = ({
  cards,
  selectedCard,
  onCardClick,
  onViewOnMap,
  layout = 'stack',
}) => {
  const containerClasses =
    layout === 'grid'
      ? 'grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4'
      : 'flex flex-col space-y-3.5';

  const isSelected = (card: CardData) => {
    if (!selectedCard) return false;
    if (selectedCard.id && card.id) {
      return selectedCard.id === card.id;
    }
    return (
      selectedCard.name === card.name &&
      selectedCard.businessName === card.businessName &&
      selectedCard.category === card.category
    );
  };

  return (
    <div className={containerClasses}>
      {cards.map((card, index) => {
        const uniqueKey = card.id || `${card.name}-${card.businessName || ''}-${index}`;
        return (
          <div key={uniqueKey} data-card={card.name}>
            <Card
              {...card}
              isSelected={isSelected(card)}
              onSelect={() => onCardClick?.(card)}
              onViewOnMap={() => onViewOnMap?.(card)}
            />
          </div>
        );
      })}
    </div>
  );
};

export default CardList;